module.exports = __webpack_public_path__ + "static/media/file.571bb5a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/file.svg
// module id = 595
// module chunks = 0